export default __webpack_public_path__ + "static/media/quiz_bg.ab3be80e.png";